const downloadExcelFromB64 = (file) =>{
    const byteCharacters = atob(file);
    var ab = new ArrayBuffer(byteCharacters.length);
    var ia = new Uint8Array(ab);
  
    for (var i = 0; i < byteCharacters.length; i++) {
        ia[i] = byteCharacters.charCodeAt(i);
    }
    var blob = new Blob([ab], {
      type: 'application/vnd.openxmlformats'
      
    });
    var link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = "Errores.xlsx";
  
    document.body.appendChild(link);
  
    link.click();
  
    document.body.removeChild(link);
  }

  export default downloadExcelFromB64


// WEBPACK FOOTER //
// ./src/utils/downloadExcelFromB64.ts